import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Index from '@/components/Index'
import Login from '@/components/Login'

import Dashboard from '@/components/admin/Dashboard'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAnonymous: true }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true, requiresAdmin: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let watcher
  if (store.getters.getLoading) {
    watcher = store.watch((state) => store.getters.getLoading, (loading) => {
      proceed()
    })
  } else {
    proceed()
  }

  function proceed () {
    if (watcher) {
      watcher()
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
      let user = store.getters.getUser
      if (user) {
        if (to.matched.some(record => record.meta.requiresAdmin)) {
          if (user.admin) {
            next()
          } else {
            next({name: 'Login'})
          }
        } else {
          next()
        }
      } else {
        next({name: 'Login'})
      }
    } else if (to.matched.some(record => record.meta.requiresAnonymous)) {
      let user = store.getters.getUser
      if (user) {
        next({name: 'Index'})
      } else {
        next()
      }
    } else {
      next
    }
  }
})

export default router

/*
 * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
 * it is only to be used only for websites.
 *
 * If you decide to go with "history" mode, please also open /config/index.js
 * and set "build.publicPath" to something other than an empty string.
 * Example: '/' instead of current ''
 *
 * If switching back to default "hash" mode, don't forget to set the
 * build publicPath back to '' so Cordova builds work again.
*/



// WEBPACK FOOTER //
// ./src/router/index.js